/* eslint-disable sonarjs/no-identical-functions */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { BlockLink, Flex, Text, Box, getPaletteColor } from 'pcln-design-system'

export const EachAltOptionContainer = styled(BlockLink)`
  display: Flex;
  text-decoration: none;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }

  ${(props) =>
    props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      width:33.3% !important;
    }`}

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      display: block;
    }`}

  ${(props) => props.theme.flyQueries.mobile} {
    &:only-child {
      width: 100%;
    }
  }
`

export const EachAltOption = styled(Flex)`
  text-decoration: none;
  margin: 4px;
  border: 1px solid ${getPaletteColor('border.base')};
  box-shadow: ${(props) => props.theme.shadows.md};
  padding: 8px;
  justify-content: space-between;
  ${(props) =>
    props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      width: 100%;
    }`}
`

export const LeftText = styled(Text)`
  line-height: 16px;
  font-size: 12px;
  display: flex;
  justify-content: left;
  flex-direction: column;
  min-width: 80px;

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      flex-direction: row;
    }`}
`

export const Day = styled(Text)`
  text-align: left;
  font-size: 10px;
  line-height: 16px;

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      width: 80px;
      font-size: 12px;
    }`}
`

export const Date = styled(Text)`
  text-align: left;
  font-size: 12px;
  line-height: 16px;
  }
`

export const LOSText = styled(Text)`
  display: block;
  font-weight: 500;
  color: ${getPaletteColor('text.light')};
  line-height: 16px;
  text-align: left;
  display: inline;
  font-size: 10px;
  padding-left: 0px;

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      font-size: 12px;
      padding-left: 16px;
    }`}
`

export const RightText = styled(Box)`
  text-align: right;
  display: flex;
  line-height: 16px;
  flex-direction: column;

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      flex-direction: row;
    }`}
`

export const NonStopText = styled(Text)`
  font-size: 10px;
  line-height: 16px;
  padding-right: 0px;
  text-align: right;

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      font-size: 12px;
      padding-right: 16px;
    }`}
`

export const CheaperText = styled(Text)`
  font-size: 11px;
  line-height: 16px;
  padding-right: 0px;
  text-align: right;

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      font-size: 12x;
      padding-right: 16px;
    }`}
`

export const FareText = styled(Text)`
  display: inline;
  font-size: 16px;
  text-align: right;
  line-height: 16px;

  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      font-size: 20px;
    }`}
`

export const CurrencySymbol = styled(Text)`
  display: inline-block;
  font-size: 10px;
  vertical-align: super;
`

function FlexDateTile(props) {
  const {
    priceDiff,
    returnDate,
    departDate,
    lengthOfStay,
    flexDatePrice,
    flexDateSearchUrl,
    navigateToFlexDateUrl,
    position,
    returnDay,
    departDay,
    displayStopsInfo,
    isSlimDesign,
  } = props

  const displayDay = departDay + (returnDay ? ' - ' : '') + returnDay
  const displayDate = departDate + (returnDate ? ' - ' : '') + returnDate

  return (
    <EachAltOptionContainer
      href='#'
      key={position - 1}
      onClick={(e) =>
        navigateToFlexDateUrl(flexDateSearchUrl + `&prev-flex-date-price=${flexDatePrice}`, position, e)
      }
      data-test='alt-option-container'
      isSlimDesign={isSlimDesign}
    >
      <EachAltOption data-autobot-eleemnt='each-alt-option' isSlimDesign={isSlimDesign} borderRadius='lg'>
        <LeftText regular data-autobot-eleemnt='alt-option-container-left-text' isSlimDesign={isSlimDesign}>
          <Day isSlimDesign={isSlimDesign}> {displayDay} </Day>
          <Date> {displayDate} </Date>
          <LOSText isSlimDesign={isSlimDesign}> {lengthOfStay} </LOSText>
        </LeftText>

        <RightText
          ml='auto'
          fontSize={0}
          data-test='savings-text'
          displayStopsInfo={displayStopsInfo}
          data-autobot-eleemnt='alt-option-container-right-text'
          isSlimDesign={isSlimDesign}
        >
          {displayStopsInfo && (
            <NonStopText
              regular
              color='text.base'
              bg='background.lightest'
              data-test='nonstop'
              isSlimDesign={isSlimDesign}
            >
              Nonstop
            </NonStopText>
          )}
          <CheaperText bold color='alert.base' isSlimDesign={isSlimDesign}>
            ${priceDiff} {'Cheaper'}
          </CheaperText>

          <FareText color='secondary.base' bold isSlimDesign={isSlimDesign}>
            <CurrencySymbol>$</CurrencySymbol>
            {flexDatePrice}
          </FareText>
        </RightText>
      </EachAltOption>
    </EachAltOptionContainer>
  )
}

export default FlexDateTile

FlexDateTile.defaultProps = {
  displayStopsInfo: false,
}

FlexDateTile.propTypes = {
  priceDiff: PropTypes.number.isRequired,
  returnDate: PropTypes.string,
  departDate: PropTypes.string.isRequired,
  lengthOfStay: PropTypes.string,
  flexDatePrice: PropTypes.number.isRequired,
  flexDateSearchUrl: PropTypes.string.isRequired,
  navigateToFlexDateUrl: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
  returnDay: PropTypes.string,
  departDay: PropTypes.string,
  displayStopsInfo: PropTypes.bool,
  isSlimDesign: PropTypes.bool,
}
